import Layout from "../../components/layout/layout";
import MobileShell from "../shell/MobileShell";
import { useIsMobile } from "../hooks/useIsMobile";

function AdaptiveAdminLayout() {
  const isMobile = useIsMobile();
  return isMobile ? <MobileShell /> : <Layout />;
}

export default AdaptiveAdminLayout;
